import { observer } from 'mobx-react';
import React, { Fragment } from 'react';
import "./FormulaContainer.scss";
import { UnderConstruction } from 'cd-eft/components/common/UnderConstruction';
import { TrapezoidalChannelFormula } from '../FormulaComponents/TrapezoidalChannel/TrapezoidalChannel';
import { PlungePoolFormula } from '../FormulaComponents/PlungePool/PlungePool';
import { HoodedInletFormula } from '../FormulaComponents/HoodedInlet/HoodedInlet';
import { FormulaBanner } from '../FormulaComponents/Common/FormulaBanner';
import { StraightDropFormula } from '../FormulaComponents/StraightDropInlet/StraightDrop';
import { BoxInletDropFormula } from '../FormulaComponents/BoxInletDrop/BoxInletDrop';
import { PipeDropFormula } from '../FormulaComponents/PipeDrop/PipeDrop';
import { DryHydrantFormula } from '../FormulaComponents/DryHydrant/DryHydrant';
import { WaterControlFormula } from '../FormulaComponents/WaterControl/WaterControl'; 
import { PressureFlowInPipeFormula } from '../FormulaComponents/PressureFlowInPipe/PressureFlowInPipe';
import { WeirFlowFormula } from '../FormulaComponents/WeirFlow/WeirFlow';
import { RectangularFormula } from '../FormulaComponents/Rectangular/Rectangular';
import { ObliqueTriangleFormula } from'../FormulaComponents/ObliqueTriangle/ObliqueTriangle';
import { ETriangleFormula } from '../FormulaComponents/EquilateralTriangle/EquilateralTriangle';
import { CubeFormula } from '../FormulaComponents/Cube/Cube';
import { SurfaceInletDrainageFormula } from '../FormulaComponents/SurfaceInletDrainage/SurfaceInletDrainage';
import { PumpDrainageFormula } from '../FormulaComponents/PumpDrainage/PumpDrainage';
import { SubsurfaceDrainageFormula } from '../FormulaComponents/SubsurfaceDrainage/SubsurfaceDrainage';

interface IFormulaContainerProps {
  title: string;
  id: number;
  section: string;
}
const FormulaContainerComponent = (props: IFormulaContainerProps) => {
  function chooseForm() {
    switch (props.title) {
      case 'Trapezoidal Channel':
        return (<TrapezoidalChannelFormula title={props.title} id={props.id} section={props.section} />);
      case 'Straight Drop Inlet':
        return (<StraightDropFormula title={props.title} id={props.id} section={props.section} />);
      case 'Box Inlet Drop':
        return (<BoxInletDropFormula title={props.title} id={props.id} section={props.section} />);
      case 'Dry Hydrant':
        return (<DryHydrantFormula title={props.title} id={props.id} section={props.section} />);
      case 'Pipe Drop':
        return (<PipeDropFormula title={props.title} id={props.id} section={props.section} />);
      case 'Plunge Pool':
        return (<PlungePoolFormula title={props.title} id={props.id} section={props.section} />);
      case 'Water Control':
        return (<WaterControlFormula title={props.title} id={props.id} section={props.section} />);
      case 'Hooded Inlet':
        return (<HoodedInletFormula title={props.title} id={props.id} section={props.section} />);
      case 'Pressure Flow in Pipe':
        return (<PressureFlowInPipeFormula title={props.title} id={props.id} section={props.section}/>); 
      case 'Weir Flow':
        return (<WeirFlowFormula title={props.title} id={props.id} section={props.section}/>);
      case 'Rectangular':
      return (<RectangularFormula title={props.title} id={props.id} section={props.section}/>);
      case 'Equilateral Triangle':
        return (<ETriangleFormula title={props.title} id={props.id} section={props.section}/>);
      case 'Surface Inlet':
        return (<SurfaceInletDrainageFormula title={props.title} id={props.id} section={props.section}/>);
      case 'Cube':
      return (<CubeFormula title={props.title} id={props.id} section={props.section}/>);
      case 'Oblique_Triangle':
        return(<ObliqueTriangleFormula title={props.title} id={props.id} section={props.section}/>);
       case 'Pump Drainage':
         return(<PumpDrainageFormula title={props.title} id={props.id} section={props.section}/>)
       case 'Subsurface Drainage':
         return(<SubsurfaceDrainageFormula title={props.title} id={props.id} section={props.section}/>)
      // Example for adding formulas.
      // return the component in a new case.
      default:
        return (
          <div className=''>
            <FormulaBanner title={props.title} help={''} />
            <div className="formula-form-container-uc">
              <UnderConstruction activeDev={true} />
            </div>
          </div>
        );
    }
  }

  return (
    <Fragment>
      <div className="formula-form-container">
        {chooseForm()}
      </div>
    </Fragment>
  );
};

export const FormulaContainer = observer(FormulaContainerComponent);
